export const viewModes = {
  CLASSICAL: 'CLASSICAL',
  PROJECTION: 'PROJECTION',
  SELFSTUDY: 'SELFSTUDY',
};

viewModes.DEFAULT = viewModes.CLASSICAL;

export default viewModes;
